import { ActionPermissionsObject, PermissionActionType } from "common/interfaces";

function hasPermission(actionPermissions, action) {
    const entry = actionPermissions?.[action];
    return Boolean(entry?.use ?? entry?.[PermissionActionType.USE]);
}

function getImageSourcePermissions(actionPermissions) {
    return {
        canGenerate: hasPermission(actionPermissions, ActionPermissionsObject.GENERATIVE_AI) &&
            hasPermission(actionPermissions, ActionPermissionsObject.GENERATIVE_AI_IMAGES),
        canUseWebSearch: hasPermission(actionPermissions, ActionPermissionsObject.WEB_IMAGES),
        canUseStockImages: hasPermission(actionPermissions, ActionPermissionsObject.STOCK_LIBRARIES)
    };
}

function resolveImageSource(imageSource, actionPermissions) {
    const { canGenerate, canUseWebSearch, canUseStockImages } = getImageSourcePermissions(actionPermissions);
    const requested = imageSource || "ai";
    const allowed = {
        ai: canGenerate,
        web: canUseWebSearch,
        stock: canUseStockImages,
        none: true
    };
    if (allowed[requested]) {
        return requested;
    }
    const fallbackOrder = ["ai", "web", "stock", "none"];
    return fallbackOrder.find(candidate => allowed[candidate]) || "none";
}

export default resolveImageSource;
